export default "/images/img_1.webp?6a2a12f8d777cf51b3001cf72e580fed";